module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"shared":{"global":{"models":{"peergroup":{"tiles":{"emerging_markets":"Emerging Markets","health":"Gesundheit","mixed_funds":"Mischfonds","pension_funds":"Rentenfonds","real_estate":"Immobilien","stock_funds":"Aktienfonds","sustainability":"Umwelt","technology":"Technologie"}}}}}}}}')
  delete Component.options._Ctor
}
